<template>
  <div>
    <div class="flex items-center space-x-4">
      <h2>Editar Cliente</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form @submit.prevent="save">
        <section-header title="Datos Personales" />

        <div class="form-grid">
          <div class="form-field">
            <label for="name">Nombre(s)</label>
            <input id="name" type="text" v-model="form.name" />
            <validation-errors :errors="errorFor('name')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="last_name">Apellido(s)</label>
            <input id="last_name" type="text" v-model="form.last_name" />
            <validation-errors
              :errors="errorFor('last_name')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="email">Correo electrónico</label>
            <input id="email" type="email" v-model="form.email" />
            <validation-errors :errors="errorFor('email')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="phone">Teléfono</label>
            <input id="phone" type="text" v-model="form.phone" />
            <validation-errors :errors="errorFor('phone')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="gender">Género</label>
            <custom-select
              v-model="form.gender"
              id="gender"
              :options="[
                { value: null, label: 'Seleccionar' },
                { value: 'Mujer', label: 'Mujer' },
                { value: 'Hombre', label: 'Hombre' },
                { value: 'Otro', label: 'Otro' },
              ]"
            />
            <validation-errors :errors="errorFor('gender')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="birthdate">Fecha de nacimiento</label>
            <custom-date-input
              id="birthdate"
              type="date"
              v-model="form.birthdate"
            />
            <validation-errors
              :errors="errorFor('birthdate')"
            ></validation-errors>
          </div>
        </div>

        <section-header title="Seguridad" />

        <div class="flex flex-col w-full">
          <div class="flex justify-between">
            <label for="password">Contraseña</label>
          </div>

          <input id="password" type="password" v-model="form.password" />

          <validation-errors :errors="errorFor('password')"></validation-errors>

          <password-validation
            class="mt-1"
            :password="form.password"
          ></password-validation>
        </div>

        <div class="flex flex-col w-full mt-4">
          <div class="flex justify-between">
            <label for="passwordConfirmation">Confirmar contraseña</label>
          </div>

          <input
            id="passwordConfirmation"
            type="password"
            v-model="form.password_confirmation"
          />

          <password-validation
            class="mt-1"
            :password="form.password"
            :passwordConfirmation="form.password_confirmation"
            :confirmation="true"
          ></password-validation>

          <validation-errors
            :errors="errorFor('password_confirmation')"
          ></validation-errors>
        </div>

        <div class="flex items-center w-full mt-6">
          <input
            id="verified"
            type="checkbox"
            v-model="form.verified"
            class="mr-2"
          />
          <label for="verified" class="cursor-pointer">Cliente Verificado</label>
        </div>

        <div class="flex items-center w-full mt-4">
          <input
            id="allows_cash_payment"
            type="checkbox"
            v-model="form.allows_cash_payment"
            class="mr-2"
          />
          <label for="allows_cash_payment" class="cursor-pointer">Permitir pago en efectivo</label>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm"
          >Guardar
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import PasswordValidation from "@/components/ui/PasswordValidation";
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Admin Form",

  components: {
    PasswordValidation,
  },

  data() {
    return {
      form: {
        name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        gender: "",
        birthdate: "",
        verified: false,
        allows_cash_payment: false,
      },
      loading: false,
      loadingForm: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "clients");

    this.loadClient();
  },

  mixins: [validationErrors],

  methods: {
    async loadClient() {
      this.loading = true;

      try {
        let client = await api.clients.getById(this.$route.params.id);
        client.email = client.user.email;
        client.verified = client.user.verified;
        client.password = "";
        client.password_confirmation = "";

        delete client.id;
        delete client.user_id;
        delete client.user;
        delete client.pets;
        delete client.branch;
        delete client.expectations;

        this.form = await JSON.parse(JSON.stringify(client));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.updateClient();
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (!this.form.last_name) {
        this.errors["last_name"] = ["Campo requerido"];
      }

      if (!this.form.email) {
        this.errors["email"] = ["Campo requerido"];
      }

      if (
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          this.form.email
        )
      ) {
        this.errors["email"] = ["Correo electrónico inválido."];
      }

      if (this.form.password !== "" || this.form.password_confirmation != "") {
        if (!this.form.password) {
          this.errors["password"] = ["Campo requerido"];
        }

        if (
          !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*.])(?=.{8,})/.test(
            this.form.password
          )
        ) {
          this.errors["password"] = ["Contraseña inválida."];
        }

        if (!this.form.password_confirmation) {
          this.errors["password_confirmation"] = ["Campo requerido"];
        }
      }

      if (this.form.password !== this.form.password_confirmation) {
        this.errors["password_confirmation"] = ["La contraseña no coincide."];
      }

      return Object.keys(this.errors).length === 0;
    },

    async updateClient() {
      this.loadingForm = true;

      try {
        const response = await api.clients.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: 'clientsDetail', params: { id: this.$route.params.id } });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>